export * from "./getFixtureCardProps";